import React from 'react';

import {
  Button, Jumbotron, Container, Row, Col,
} from 'react-bootstrap';

import './HomePage.css';

function HomePage() {
  const text1 = `
  At AllKiosk, we are about doing all the things to help you and your business succeed. Using our expertise in kiosk design and integration, we can bring to you a complete solution that solves your problems. You might be here because you have a great idea for a self-service kiosk, or you might be here because your kiosks are constantly failing. Those are the types of reason why our company exists. In a sea of self-service kiosks that all look the same, the issue we always see is the customer not getting the results they want. The self-service kiosks from the other companies are rebranded kiosks that are cheaply manufactured for general purposes. When we design a kiosk, there are multiple considerations we take into account before providing you with a solution so the kiosk you buy from us stays online.
  `;
  const text2 = `
  AllKiosk began in 2004 when founders George and Jennifer Graves recognized an opportunity to help utilities improve customer satisfaction and reduce operational costs. Since partnering with Salt River Project (SRP), AllKiosk has leveraged the expertise of GECO, its aerospace engineering parent company, to design and manufacture integrated bill payment terminals which support utilities payment infrastructure throughout the US.

  Over a decade later—and after two generations of ruggedized builds—AllKiosk provides industry-leading products, market leadership, and field-proven deployments in high use areas. We’ve been able to help our customers leverage new, back-end integrated products and provide their customers with greater flexibility, security, and satisfaction.
  
  Our kiosks have helped our customers to decrease operating expenses and arrears, recognize revenue upfront in near real-time, and give end-users unprecedented control and knowledge of their usage. As we continue to grow, AllKiosk remain steadfast in our commitment to providing quality custom kiosk solutions that help our customers meet their goals, and ongoing service and support for our customers.
  
  AllKiosk is ISO 9001 certified.
  `;
  const text3 = `

  Have questions or want to talk with us about how we can help you? Give us a call or email to get started!

  Phone: (480) 590-6570
  
  4836 E Indigo Street #102
  
  Mesa, AZ 85205
  
  info@allkiosk.com  
  `;

  return (
    <Container fluid className="noPadding">
      <Row noGutters>
        <Col>
          <Jumbotron fluid style={{ backgroundColor: '#282c34' }}>
            <h1>Cloud Administrative Service</h1>
            <p>Welcome to AllKiosk CAS!</p>
            <p>
              <Button variant="outline-light">Learn more</Button>
            </p>
          </Jumbotron>
        </Col>
      </Row>
      <Row noGutters>
        <Col className="centralized">
          <h3>How it Works</h3>
          <p>{text1}</p>
        </Col>
        <Col className="centralized">
          <h3>About Us</h3>
          <p>{text2}</p>
        </Col>
        <Col className="centralized">
          <h3>Contact Us</h3>
          <p>{text3}</p>
        </Col>
      </Row>
    </Container>
  );
}

export default HomePage;
